var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nx-signing-modal-merge-doc"},[_c('h4',[_vm._v(_vm._s(_vm.$t('MergingSign')))]),_c('h5',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('PleaseWait')))]),_c('div',{staticClass:"mt-4"},[_c('b-spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }